import { TagType } from 'generated/graphql';
import { postMessageToEngine } from 'lib/postMessageToEngine';
import { isEmbeddedInEngine } from 'lib/useIsEmbeddedInEngine';
import { isClientSide } from 'utils/isClientSide';

type Providers = 'email' | 'google' | 'username' | 'wallet';
export type AccountCreatedEvent = {
  event: 'account_created';
  provider: Providers;
};
type GamePublishedEvent = {
  event: 'game_published';
};
type DeveloperTokenCreatedEvent = {
  event: 'developer_token_created';
};
type UserTaggedSelfEvent = {
  event: 'user_tagged_self';
  name: string;
  type: TagType;
};
type ProductEvent = {
  product_id: string;
  product_name: string;
  currency: string;
  unit_amount: number;
};

type ProductViewedEvent = ProductEvent & {
  event: 'view_item';
};

type ProductInitiatedCheckoutEvent = ProductEvent & {
  event: 'initiate_checkout';
};

type ProductPurchasedEvent = ProductEvent & {
  event: 'purchase';
  transaction_id: string;
};

export type GTagEvent =
  | GamePublishedEvent
  | AccountCreatedEvent
  | DeveloperTokenCreatedEvent
  | UserTaggedSelfEvent
  | ProductViewedEvent
  | ProductInitiatedCheckoutEvent
  | ProductPurchasedEvent;

export const gtagRecordEvent = (event: GTagEvent): void => {
  if (!isClientSide()) {
    return;
  }

  const url = new URL(window.location.href);
  const eventSource = url.searchParams.get('eventSource') ?? '';

  if (isEmbeddedInEngine(eventSource)) {
    postMessageToEngine({ type: 'gtagRecordEvent', value: event });
    return;
  }

  const dataLayer = window.dataLayer ?? [];

  dataLayer.push(event);
};
